import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function DotsIcon({ className, size = 20, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        d="M3.81104 11.25C3.12068 11.25 2.56104 11.8096 2.56104 12.5C2.56104 13.1904 3.12068 13.75 3.81104 13.75H3.82576C4.51612 13.75 5.07576 13.1904 5.07576 12.5C5.07576 11.8096 4.51612 11.25 3.82576 11.25H3.81104Z"
        fill="currentColor"
      />
      <path
        d="M10.6974 12.5C10.6974 11.8096 11.257 11.25 11.9474 11.25H11.9621C12.6525 11.25 13.2121 11.8096 13.2121 12.5C13.2121 13.1904 12.6525 13.75 11.9621 13.75H11.9474C11.257 13.75 10.6974 13.1904 10.6974 12.5Z"
        fill="currentColor"
      />
      <path
        d="M18.8337 12.5C18.8337 11.8096 19.3934 11.25 20.0837 11.25H20.0985C20.7888 11.25 21.3485 11.8096 21.3485 12.5C21.3485 13.1904 20.7888 13.75 20.0985 13.75H20.0837C19.3934 13.75 18.8337 13.1904 18.8337 12.5Z"
        fill="currentColor"
      />
    </svg>
  )
}
